import { createContext, type RefObject } from "react";

export type BankingLeaveGuard = () => Promise<void>;

// The banking page registers its check here so the workflow tracker, which lives above it, can wait
// on the same question before leaving. A rejection means the customer stays on the page.
export const BankingLeaveGuardContext = createContext<{ current: BankingLeaveGuard | null }>({ current: null });

export type BankingLeaveGuardRef = RefObject<BankingLeaveGuard | null>;
